// index.js in routes folder
import { useRoutes } from "react-router-dom";

// routes
import MainRoutes from "./MainRoutes";
import AuthenticationRoutes from "./AuthenticationRoutes";
import LoginRoutes from "./LoginRoutes";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([...MainRoutes, AuthenticationRoutes, LoginRoutes]);
}
